import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  background: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${Spacing.Xxs};
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};
  padding: ${Spacing.S};
  width: 100%;
`;

export const UserSection = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 1rem;
`;
